<template>
  <div class="content" ref="content">
    <div v-if="iscn" class="text-believe header1 animate__animated">
      <div class="text-title">我们相信循环二手是解决方案</div>
      <div class="text-desc">
        <p>循环二手，是减少生产制造产生的碳排放的重要途径。</p>
        <p>通过循环经济中的再使用(Reuse) 和再循环(Recycle)，延长物品的使用周期和寿命， 更高效地利用资源，减少碳排放！</p>
        <p>以一部二手手机为例，每交易一部二手手机，可帮助地球减少25kg的碳排放，平板电脑、 家电等会减少更多！</p>
      </div>
    </div>
    <div v-if="!iscn" class="text-believe text-en header1 animate__animated">
      <div class="text-title">We believe second-hand is the solution</div>
      <div class="text-desc">
        <p>Second-hand and circulation is an effective way to reduce carbon emissions from manufacturing.</p>
        <p>Reusing and recycling used products, guided by the 3R principle (Reduce, Reuse, Recycle),</p>
        <p>can effectively contribute to reducing carbon emissions and optimizing resource utilization!</p>
        <p>Take second-hand mobile phone as an example, for every second-hand mobile phone traded, 25kg carbon emissions can be reduced,</p>
        <p>and even more for tablets, home appliances, and other devices!</p>
      </div>
    </div>
    <div class="chart">
      <img v-if="iscn" class="zhuzhuangtu" src="../assets/zhuzhuangtu.png" alt="">
      <img v-else class="zhuzhuangtu" src="../assets/zhuzhuangtu-en.png" alt="">
      <img v-if="iscn" class="paifangliang" src="../assets/paifangliang.png" alt="">
      <img v-else class="paifangliang paifangliang-en" src="../assets/paifangliang-en.png" alt="">
    </div>
    <div v-if="iscn" class="text-believe header2 animate__animated">
      <div class="text-title">我们让二手这件事变得更好</div>
      <div class="text-desc">
        <p>二手等于脏、乱、差？不！在我们的努力下，转转首创有服务交易模式——官方验，让二手商品也可以靠谱好用， </p>
        <p>买卖二手也可以像买新品一样安心、省心和放心，让人们省钱的同时，拯救地球！</p>
      </div>
    </div>
    <div v-if="!iscn" class="text-believe header2 animate__animated">
      <div class="text-title">We make second-hand better</div>
      <div class="text-desc">
        <p>Second-hand doesn’t have to mean dirty, messy, and low quality. </p>
        <p>Through our efforts, ZhuanZhuan has pioneered a service-driven transaction model—official verification—ensuring second-hand products are just as reliable and functional as new ones.</p>
        <p>Buying and selling second-hand items can be as easy, secure, and worry-free as buying brand new, helping people save money while saving the planet!</p>
      </div>
    </div>
    <div v-if="iscn" class="shop">
      <div class="shop-item">
        <img src="../assets/zhijian.png" alt="">
        <div class="title">智能质检中心</div>
        <div class="sub-title">3</div>
      </div>
      <div class="shop-item">
        <img src="../assets/gongchengshi.png" alt="">
        <div class="title">上门回收工程师团队</div>
        <div class="sub-title">2000+</div>
      </div>
      <div class="shop-item">
        <img src="../assets/mendian.png" alt="">
        <div class="title">门店</div>
        <div class="sub-title">1000+</div>
      </div>
    </div>
    <div v-if="!iscn" class="shop">
      <div class="shop-item">
        <img src="../assets/zhijian.png" alt="">
        <div class="title">intelligent quality inspection centers</div>
        <div class="sub-title">3</div>
      </div>
      <div class="shop-item">
        <img src="../assets/gongchengshi.png" alt="">
        <div class="title">door-to-door service engineers</div>
        <div class="sub-title">2000+</div>
      </div>
      <div class="shop-item">
        <img src="../assets/mendian.png" alt="">
        <div class="title">stores</div>
        <div class="sub-title">1000+</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Rellax from 'rellax'

export default Vue.extend({
  name: 'earth-waring-area',
  computed: {
    iscn: function() {
      return this.$store.state.lang === 'zh-cn'
    }
  },
  mounted() {
    this.initAnimation()

    new Rellax('.header1', {
      speed: -0.3,
      center: true,
      wrapper: null,
      round: true,
      vertical: true,
      horizontal: false
    })
    new Rellax('.chart', {
      speed: 1,
      center: true,
      wrapper: null,
      round: true,
      vertical: true,
      horizontal: false
    })
    new Rellax('.header2', {
      speed: -0.1,
      center: true,
      wrapper: null,
      round: true,
      vertical: true,
      horizontal: false
    })
    new Rellax('.shop', {
      speed: 1,
      center: true,
      wrapper: null,
      round: true,
      vertical: true,
      horizontal: false
    })
  },
  methods: {
    initAnimation() {
      // 监听滚动事件，当元素earthPic进入视口时，给元素增加动画类
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            // 柱状图标题
            if (entry.target.classList.contains('header1') && entry.isIntersecting) {
              setTimeout(() => {
                document.querySelector('.header1')?.classList?.add('animate__fadeIn')
              }, 70)
            }
            // 柱状图部分
            if (entry.target.classList.contains('chart') && entry.isIntersecting) {
              setTimeout(() => {
                document.querySelector('.chart')?.classList?.add('zoom-in-fast')
              }, 70)
            }
            // 二手图标题
            if (entry.target.classList.contains('header2') && entry.isIntersecting) {
              setTimeout(() => {
                document.querySelector('.header2')?.classList?.add('animate__fadeIn')
              }, 70)
            }
            // 二手图部分
            if (entry.target.classList.contains('shop') && entry.isIntersecting) {
              setTimeout(() => {
                document.querySelectorAll('.shop-item').forEach((item) => {
                  item.classList.add('zoom-in')
                })
              }, 70)
            }
          })
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: 0.2
        }
      )
      observer.observe(document.querySelector('.chart') as Element)
      observer.observe(document.querySelector('.header1') as Element)
      observer.observe(document.querySelector('.header2') as Element)
      observer.observe(document.querySelector('.shop') as Element)
    }
  }
})
</script>

<style scoped lang="scss">
@keyframes zoomIn {
  from {
    transform: scale3d(0.7, 0.7, 0.7);
    opacity: 0;
  }

  50% {
    opacity: 0.3;
  }

  to {
    transform: scale3d(1, 1, 1);
    opacity: 1;
  }
}

@keyframes zoomInPic {
  from {
    transform: scale3d(0.9, 0.9, 0.9);
    opacity: 0;
  }

  to {
    transform: scale3d(1, 1, 1);
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(200px);
  }

  to {
    transform: translateY(0);
  }
}

.zoom-in {
  animation: zoomIn 1s 0s forwards;
  animation-timing-function: linear;
}

.zoom-in-fast {
  animation: zoomIn 800ms 0s forwards;
  animation-timing-function: linear;
}

.content {
  position: relative;
  z-index: 3;
  width: 1920px;
  min-width: 1280px;
  max-width: 1920px;
  // max-width: 1513px;
  // height: 2925px;
  margin: 0 auto;
  background: #fff;
}

.text-believe {
  opacity: 0;
  .text-title {
    font-family: alibaba;
    font-weight: 1000;
    font-size: 56px;
    color: #111111;
    line-height: 56px;
    text-align: center;
    padding-bottom: 80px;
  }
  .text-desc {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #111111;
    line-height: 32px;
    text-align: center;
    font-style: normal;
    // padding-bottom: 20px;
  }
}
.chart {
  width: 1513px;
  position: relative;
  padding-bottom: 280px;
  opacity: 0;
  margin: 100px auto 0;
  .zhuzhuangtu {
    width: 100%;
  }
  .paifangliang {
    position: absolute;
    top: 6px;
    right: 112px;
    width: 192px;
    height: 73px;
    &.paifangliang-en {
      width: 439px;
    }
  }
}
.shop {
  display: flex;
  justify-items: center;
  justify-content: space-between;
  width: 1513px;
  margin: 100px auto 0;
}
.shop-item {
  width: 475px;
  height: 620px;
  text-align: center;
  position: relative;
  opacity: 0;
  img {
    width: 100%;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
  .title {
    padding-top: 474px;
    position: relative;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 24px;
    color: #000000;
    line-height: 24px;
    text-align: center;
    font-style: normal;
  }
  .sub-title {
    padding-top: 24px;
    position: relative;
    font-family: alibaba;
    font-weight: 1000;
    font-size: 56px;
    color: #111111;
    line-height: 40px;
    text-align: center;
  }
}
</style>
